<template src="./UserAddUpdate.html"></template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("user");
import kendo from "@progress/kendo-ui";
// import { MESSAGES } from "@/utils/constants";
// import { notify, notifyApiError } from "@/utils/notification-helper";

export default {
  data: function() {
    return {
      add: this.$route.params.add,
      username: null,
      userData: {},
      email: "",
      // emailConfirmed: "",
      password: "",
      phoneNumber: "",
      roles: {},
      zone: {}
    };
  },
  methods: {
    goToListPage: function() {
      this.$router.push({ name: "UserManagement" });
    },
    clearAll: function() {
        (this.username = null),
        (this.email = null),
        (this.phoneNumber = null),
        (this.roles = null),
        (this.zone = null);
    },
    handleChange(event) {
      this.roles = event.value;
    },
    addUser: function() {
      if (
        this.email &&
        this.phoneNumber &&
        this.roles &&
        this.zone
      ) {
        let newRoles = this.roles;
        for (var key in newRoles) {
          newRoles[key.charAt(0).toUpperCase() + key.substring(1)] = newRoles[key];
          delete newRoles[key];
        }
        this.userData = {
          // name: this.name,
          userName: this.email,
          email: this.email,
          phoneNumber: this.phoneNumber,
          Roles: [newRoles],
          ZoneID: this.zone.id
        };
        if (this.add) {
          this.$store.dispatch("user/addUsers", this.userData).then(() => {
            // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            this.goToListPage();
            this.clearAll();
          });
          // .catch(notifyApiError);
        } else {
          this.$store.dispatch("user/updateUser", this.userData).then(() => {
            // notify(MESSAGES.CHANGES_SAVE_SUCCESS);
            this.goToListPage();
            this.clearAll();
          });
          // .catch(notifyApiError);
        }
      }
    },
    async getDataOnload() {
      this.$store.dispatch("user/roleList");
      this.$store.dispatch("user/getZones");
    }
  },

  computed: {
    ...mapState({
      roleList: state => state.roles,
      zoneList: state => state.zones
    }),
    localDataSource() {
      return new kendo.data.HierarchicalDataSource({
        data: this.zoneList,
        schema: {
          model: {
            children: "subZone"
          }
        }
      });
    }
  },
  beforeMount() {
    if (!this.$route.params.add) {
      this.userEditData = this.$store.getters["user/newUser"];
      // this.name = this.userEditData.userName;
      this.username = this.userEditData.username
      this.email = this.userEditData.email;
      this.phoneNumber = this.userEditData.phoneNumber;
      this.zone = this.zoneList.find(
        obj => obj.id == this.userEditData.zoneID
      );
      this.roles = this.userEditData.roles[0];
    }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>


